/* @flow */
import React from 'react';
import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import OrganizationAccountActions from 'actions/OrganizationAccountActions';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions';
import TosText from 'components/TosText.jsx';
import { redirector } from 'auth/components/SignInPage.jsx';
import invariant from 'invariant';

import JoinPageLoadingIndicator from './JoinPageLoadingIndicator.jsx';

import './styles/JoinClaimDirectAddAccount.scss';

const EVENT_SCREEN_NAME = 'JoinClaimDirectAddAccount';

const JoinClaimDirectAddAccount = React.createClass({
  propTypes: {
    location: React.PropTypes.object.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  childContextTypes: {
    eventScreenName: React.PropTypes.string,
  },

  getInitialState() {
    const { query } = this.props.location;

    invariant(query.token, 'missing token');

    return {
      token: query.token,
      isValid: false,
      account: null,
    };
  },

  getChildContext() {
    return {
      eventScreenName: EVENT_SCREEN_NAME,
    };
  },

  componentDidMount() {
    this.loadAccount();
  },

  onSubmit(attrs: Object) {
    OrganizationAccountActions.claimAccount(this.state.token, attrs.password)
      .then(
        () => this.context.router.push('/classes?origin=subscribed'),
        () => ToastActions.showDefaultErrorToast(),
      );
  },

  loadAccount() {
    const onSuccess = ([account, isLoggedIn]) => {
      if (isLoggedIn) {
        this.context.router.push({
          pathname: '/classes?origin=subscribed',
          query: this.props.location.query,
        });
      } else {
        this.setState({ account });
        this.refs.password.refs.children.focus();
      }
    };
    const onError = () => ToastActions.showDefaultErrorToast();

    const isLoggedIn = new Promise(function(resolve) {
      AuthActions.checkLoggedIn().then(() => resolve(true), () => resolve(false));
    });
    const accountPromise = OrganizationAccountActions.getOrLoadAccount(this.state.token);
    Promise.all([accountPromise, isLoggedIn]).then(onSuccess, onError);
  },

  goToSignIn() {
    // XXX
    redirector.onSignInRedirectTo = {
      pathname: '/classes?origin=subscribed',
      query: this.props.location.query,
    };
    this.context.router.push('/log_in');
  },

  rejectAccount() {
    OrganizationAccountActions.rejectAccount(this.state.token);
    this.context.router.push('/sign_up');
  },

  render() {
    if (!this.state.account) {
      return <JoinPageLoadingIndicator />;
    }

    const { account } = this.state;
    const headerImage = (
      <Image
        className="JoinClaimDirectAddAccount-headerImage"
        src={require('assets/images/school-circle.svg')}
      />
    );

    return (
      <DialogContent
        className="JoinClaimDirectAddAccount"
        title={`Hi ${account.user_name}!`}
        headerImageComponent={headerImage}
        size="small"
        subtext={
          `${account.from_admin_name} has invited you to join ` +
          `${account.organization_name} on Remind with the email address ` +
          `${account.user_email}.`
        }>
        <BoxBody>
          <Text size="xsmall">
            <Link
              className="wrong_email"
              onClick={this.rejectAccount}
              eventElementName="wrong_email">
              <Text weight="semibold">
                  Not you
              </Text>
            </Link>
            {' '}
            <Text color="thunder">
              or
            </Text>
            {' '}
            <Link
              className="already_have_account"
              onClick={this.goToSignIn}
              eventElementName="already_have_account">
              <Text weight="semibold">
                already have an account?
              </Text>
            </Link>
          </Text>
          <Form
            onSubmit={this.onSubmit}
            onValid={() => this.setState({ isValid: true })}
            onInvalid={() => this.setState({ isValid: false })}>
            <div className="JoinClaimDirectAddAccount-password">
              <FormInput
                label="Create a password"
                autoComplete="new-password"
                className="JoinClaimDirectAddAccount-passwordInput"
                ref="password"
                name="password"
                type="password"
                size="large"
                placeholder="Password"
                showErrorAfterBlur
                validations="minLength:6"
                validationErrors={{
                  minLength: 'Passwords should be at least 6 characters long.',
                }}
              />
            </div>
            <Button
              className="submit_password JoinClaimDirectAddAccount-submitButton"
              disabled={!this.state.isValid}
              type="submit"
              level="primary"
              eventElementName="submit_password JoinClaimDirectAddAccount-submitButton">
              Continue
            </Button>
          </Form>
          <TosText />
        </BoxBody>
      </DialogContent>
    );
  },

});

export default JoinClaimDirectAddAccount;



// WEBPACK FOOTER //
// ./src/join/components/JoinClaimDirectAddAccount.jsx